import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Card, Alert } from "react-bootstrap";
import api from "../api";
import { AuthContext } from "../AuthContext";
import { dashboardPathFor } from "../dashboardPath";

export default function LoginPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [infoMessage, setInfoMessage] = useState("");

  useEffect(() => {
    const reason = sessionStorage.getItem("hhh_logout_reason");
    if (reason === "inactivity") {
      sessionStorage.removeItem("hhh_logout_reason");
      setInfoMessage("You were logged out due to 15 minutes of inactivity.");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const res = await api.post("/auth/login", { username, password });
      login(res.data.user, res.data.access_token);
      navigate(dashboardPathFor(res.data.user));
    } catch (err) {
      setError(
        err.response?.data?.error || "Login failed. Check username and password."
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="mx-auto" style={{ maxWidth: 400 }}>
      <Card.Body>
        <Card.Title>Login</Card.Title>
        {infoMessage && <Alert variant="warning">{infoMessage}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="loginUsername">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="loginPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Form.Group>

          <Button type="submit" variant="primary" disabled={busy}>
            {busy ? "Logging in..." : "Login"}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
}
